<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> Import Easycheck Marks </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            dense
            required
            outlined
            rounded
            color="#0F2027"
            v-model="sem"
            :items="semester_list"
            item-text="display_name"
            item-value="id"
            label="Semester"
            @change="getassessmentschemedetails()"
            persistent-hint
            hint="Please select semester"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="assessment_detail_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="assessment_detail"
            return-object
            :items="assessment_detail_list"
            item-text="assessmenttype"
            label="Assessment Scheme Details"
            outlined
            persistent-hint
            hint="Please select assessment scheme type"
          />
        </v-col>
      </v-row>
      <v-row
        justify="center"
        align="center"
        v-if="sem != null && assessment_detail != null"
      >
        <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
          <v-file-input
            placeholder="CSV of student data"
            prepend-icon="mdi-file"
            label="Student Data"
            show-size
            flat
            rounded
            outlined
            dense
            v-model="file"
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
          <a
            href="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Documents/learner_easycheck_marks_entry.csv"
          >
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              outlined
              class="ma-2 white--text downbtn button"
              @click="loader = 'loading3'"
            >
              Download import CSV format
              <v-icon right dark>mdi-cloud-download</v-icon>
            </v-btn>
          </a>
        </v-col>
      </v-row>

      <v-row
        justify="center"
        align="center"
        v-if="sem != null && assessment_detail != null && file != null"
      >
        <v-btn class="button" @click="submitFile">Submit</v-btn>
      </v-row>

      <!-- shiv new code -->
      <v-col cols="12" sm="12" md="12">
        <template v-if="load == false">
          <v-simple-table class="mytable">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Student</th>
                  <th class="text-left">Subject Code</th>
                  <th class="text-left">Exam Type</th>
                  <th class="text-left">Finak Marks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1000000043</td>
                  <td>806</td>
                  <td>EVA - I</td>
                  <td>19</td>
                </tr>
                <tr>
                  <td class="mandatory">Mandatory</td>
                  <td class="mandatory">Mandatory</td>
                  <td class="mandatory">Mandatory</td>
                  <td class="mandatory">Mandatory</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-col>
      <!-- shiv code end -->

      <span v-if="statuslist != ''">
        <v-col
          cols="12"
          sm="12"
          md="12"
          v-if="statuslist.statuslist[0].faillist != ''"
        >
          <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Failed Students Data</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <download-excel
            class="ma-2 no-display"
            color="primary"
            dark
            :data="statuslist.statuslist[0].faillist"
            :fields="xls_header1"
            worksheet="Failed Data"
            name="Failed_Data.xls"
          >
            <v-btn class="ma-2 no-display" tile outlined color="success">
              <v-icon left>mdi-file-excel</v-icon> Excel
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </download-excel>
          <template>
            <v-data-table
              dense
              :headers="headers1"
              :items="statuslist.statuslist[0].faillist"
              sort-by
              class="elevation-1 mytable"
              :search="search"
            ></v-data-table>
          </template>
        </v-col>

        <v-col
          cols="12"
          sm="12"
          md="12"
          v-if="statuslist.statuslist[0].statuslist != ''"
        >
          <template>
            <v-data-table
              dense
              :headers="headers"
              :items="statuslist.statuslist[0].statuslist"
              sort-by
              class="elevation-1 mytable"
              :search="search"
            >
              <template v-slot:top>
                <v-toolbar flat dense class="toolbar">
                  <v-toolbar-title>Success Students Data</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-toolbar
                  flat
                  dense
                  color="white"
                  align="center"
                  justify="center"
                >
                  <download-excel
                    class="ma-2 no-display"
                    color="primary"
                    dark
                    :data="statuslist.statuslist[0].statuslist"
                    :fields="xls_header"
                    worksheet="Success_Data"
                    name="Success_Data.xls"
                  >
                    <v-btn
                      class="ma-2 no-display"
                      tile
                      outlined
                      color="success"
                    >
                      <v-icon left>mdi-file-excel</v-icon> Excel
                      <v-icon right>mdi-download</v-icon>
                    </v-btn>
                  </download-excel>
                </v-toolbar>
              </template>
            </v-data-table>
          </template>
        </v-col>
      </span>
    </v-card>
    <div class="text-center">
      <v-dialog v-model="output_load" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please Wait
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      file: null,
      statuslist: [],
      load: false,
      loading3: false,
      overlay: false,
      selected: [],
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      semester_list: null,
      sem: null,
      fetch_loader: false,
      assessment_detail_list: [],
      assessment_detail: null,
      xls_header: {
        SR_No: "sr.no",
        PRN_No: "grno",
        Status: "status",
        Marks: "marks",
      },
      headers: [
        { text: "Sr.NO", value: "sr.no" },
        { text: "PRN No", value: "grno" },
        { text: "Status", value: "status" },
        { text: "Marks", value: "marks" },
      ],
      xls_header1: {
        PRN_No: "grno",
        Status: "status",
        Remark: "remark",
      },
      headers1: [
        { text: "PRN No", value: "grno" },
        { text: "Status", value: "status" },
        { text: "Reason", value: "remark" },
      ],
      output_load: false,
    };
  },

  methods: {
    submitFile() {
      this.load = true;
      if (this.file == null) {
        alert("Please select the file!");
      } else {
        this.output_load = true;
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("sem", this.sem);
        formData.append("ass_type", this.assessment_detail.id);
        axios
          .post("Examination/importEasycheckmarks", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.status == "NO") {
              this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
            } else {
              this.statuslist = res.data;
              this.output_load = false;
              this.showSnackbar("#4caf50", "Data Imported Successfully..."); // show snackbar on success
            }
          })
          .catch(function () {
            console.log("FAILURE!!");
            this.output_load = false;
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    },

    getassessmentschemedetails() {
      axios
        .post("/Examination/getAssType")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.assessment_detail_list = res.data.assessment_detail_list;
          }
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.semester_list = res.data.sem_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.downbtn {
  float: right;
}

/* new css */
table,
th {
  padding: 10px;
  border: 1px solid black;
  border-collapse: collapse;

  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.mandatory {
  color: red;
}
</style>
